import useTranslator from "../../hooks/useTranslator";

// Quote-bubble icon shared by both "View note" pills (tenant + landlord)
// so they always stay identical.
export function ViewNoteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M14 14a2 2 0 0 0 2-2V8h-2" />
      <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
      <path d="M8 14a2 2 0 0 0 2-2V8H8" />
    </svg>
  );
}

// "View note" action for a missing document covered by the tenant's
// explanation note. Opens the profile explanation modal. Tenant-only:
// DetailsDocs passes onViewNote solely on the tenant's own profile view.
// Rendered as a grey pill (same shape as the landlord note pill).
// Stops propagation because missing rows also carry their own click
// handlers (e.g. the document-history opener).
const ViewMissingDocNoteButton = ({ onViewNote }) => {
  const { _t } = useTranslator();
  if (typeof onViewNote !== "function") return null;
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onViewNote();
      }}
      className="cursor-pointer d-flex align-items-center custom-gap-2 view-doc-button"
      style={{
        background: "#f2f2f2",
        border: 0,
        borderRadius: 999,
        padding: "2px 10px",
      }}
    >
      <ViewNoteIcon />
      {_t("viewNote", "View note")}
    </button>
  );
};

export default ViewMissingDocNoteButton;
